import { Text, Layout } from '@loadsmart/miranda-react'

import { type StopAppointment } from '../domain/Appointment'
import {
  formatAppointmentDate,
  formatAppointmentDescription,
  formatAppointmentStatus,
  formatAppointmentStatusColor,
} from '../presenters/appointmentPresenter'

export function AppointmentStatus({ appointment }: { appointment?: StopAppointment }) {
  if (!appointment) {
    return null
  }

  const date = formatAppointmentDate(appointment)
  const label = formatAppointmentStatus(appointment.status)
  const description = formatAppointmentDescription(appointment)
  const labelColor = formatAppointmentStatusColor(appointment.status)

  return (
    <Layout.Group gap="spacing-0-5">
      <Text variant="body-sm" color="color-text-tertiary">
        {date} •
      </Text>
      <Text variant="body-sm" color={labelColor}>
        {label}
      </Text>
      {description && (
        <Text variant="body-sm" color="color-text-tertiary">
          {' '}
          {description}
        </Text>
      )}
    </Layout.Group>
  )
}
